import React from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
      
const AnalysisPage = () => {
  const data = [
    {
      testName: "com.productmadness.automation.tests.smoke.game.SpinTest",
      failedWith:
        "Game screen is not opened expected [true] but found [false]",
      count: 63,
      versions: { ver1: 5, ver2: 55, ver3: 3, ver4: 0 },
    },
    {
      testName:
        "com.productmadness.automation.tests.smoke.lobby.EarlyAccessTargetCrmTest",
      failedWith:
        "Game 'Buffalo Clone' is not present in beginning of Lobby expected [true] but found [false]",
      count: 3,
      versions: { ver1: 1, ver2: 2, ver3: 0, ver4: 0 },
    },
  ];

  const versionColumns = ["ver1", "ver2", "ver3", "ver4"];

  const renderVersions = (rowData) => {
    return (
      <div style={{ display: "flex", gap: "10px" }}>
        {versionColumns.map((version, index) => (
          <div key={index}>
            <strong>{version}:</strong> {rowData.versions[version]}
          </div>
        ))}
      </div>
    );
  };

  const onPlotButtonClick = () => {
    alert("Navigating to chronological view (Page 4)");
  };

  return (
    <div className="p-p-4" style={{ fontFamily: "Arial, sans-serif" }}>
      <h1>Analyisis Page</h1>
      <p>Sum of test failures for all selected versions:</p>

      <DataTable
        value={data}
        responsiveLayout="scroll"
        header="Test Failures Summary"
      >
        <Column field="testName" header="Test Name" style={{ width: "30%" }} />
        <Column
          field="failedWith"
          header="Failed With"
          style={{ width: "30%" }}
        />
        <Column field="count" header="Count" style={{ width: "10%" }} />
        {versionColumns.map((version) => (
          <Column
            key={version}
            field={`versions.${version}`}
            header={version}
            style={{ width: "10%" }}
          />
        ))}
      </DataTable>
        <br/>
      <Button
        label="Plot"
        icon="pi pi-chart-line"
        className="p-mt-3"
        style={{ width: "200px" }}
        onClick={onPlotButtonClick}
      />
    </div>
  );
};

export default AnalysisPage;
